export const getExpoName = () => {
  // http://localhost:3000/aap2025/#/sessions
  const expoName = window.location.pathname.replace(/\//g, '');
  console.log('expoName', expoName);
  if (expoName === '') {
    const baseUrl = window.location.origin;
    const msg = `Could not get expoName from URL. Try setting CONGRESS_NAME in ${baseUrl}/CONGRESS_NAME/#/sessions`;
    console.error(msg);
    alert(msg);
    throw new Error(msg);
  }
  return expoName;
};
